import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { FilterMatchMode, PrimeReactProvider } from 'primereact/api';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import { SnackbarProvider } from 'notistack';
// import "primereact/resources/themes/bootstrap4-light-purple/theme.css"
import { Provider } from 'react-redux';
import { persistor, store } from './store/Reduxstore';
import App from './App';
import { PersistGate } from 'redux-persist/integration/react';
// import "primereact/resources/themes/saga-orange/theme.css"
import "primereact/resources/themes/saga-purple/theme.css"
// import "primereact/resources/themes/bootstrap4-light-blue/theme.css"


// import "primereact/resources/themes/fluent-light/theme.css"
// import "primereact/resources/themes/saga-blue/theme.css"
// import "primereact/resources/themes/saga-green/theme.css"



// import "primereact/resources/themes/bootstrap4-dark-blue/theme.css"
// import "primereact/resources/themes/bootstrap4-dark-purple/theme.css"
// import "primereact/resources/themes/md-light-indigo/theme.css"
// import "primereact/resources/themes/md-light-deeppurple/theme.css"
// import "primereact/resources/themes/md-dark-indigo/theme.css"
// import "primereact/resources/themes/md-dark-deeppurple/theme.css"
// import "primereact/resources/themes/mdc-light-indigo/theme.css"
// import "primereact/resources/themes/mdc-light-deeppurple/theme.css"
// import "primereact/resources/themes/mdc-dark-indigo/theme.css"
// import "primereact/resources/themes/mdc-dark-deeppurple/theme.css"
// import "primereact/resources/themes/tailwind-light/theme.css"
// import "primereact/resources/themes/lara-light-blue/theme.css"
// import "primereact/resources/themes/lara-light-indigo/theme.css"
// import "primereact/resources/themes/lara-light-purple/theme.css"
// import "primereact/resources/themes/lara-light-teal/theme.css"
// import "primereact/resources/themes/lara-dark-blue/theme.css"
// import "primereact/resources/themes/lara-dark-indigo/theme.css"
// import "primereact/resources/themes/lara-dark-purple/theme.css"
// import "primereact/resources/themes/lara-dark-teal/theme.css"
// import "primereact/resources/themes/soho-light/theme.css"
// import "primereact/resources/themes/soho-dark/theme.css"
// import "primereact/resources/themes/viva-light/theme.css"
// import "primereact/resources/themes/viva-dark/theme.css"
// import "primereact/resources/themes/mira/theme.css"
// import "primereact/resources/themes/nano/theme.css"
// import "primereact/resources/themes/vela-blue/theme.css"
// import "primereact/resources/themes/vela-green/theme.css"
// import "primereact/resources/themes/vela-orange/theme.css"
// import "primereact/resources/themes/vela-purple/theme.css"
// import "primereact/resources/themes/arya-blue/theme.css"
// import "primereact/resources/themes/arya-green/theme.css"
// import "primereact/resources/themes/arya-orange/theme.css"
// import "primereact/resources/themes/arya-purple/theme.css"
        

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// PrimeReact configuration
const primeReactConfig = {
  locale: 'en',
  ripple: true,
  nullSortOrder: 1,
  // inputStyle: 'filled',
  cssTransition: false,
  // appendTo: 'body' as 'body',
  hideOverlaysOnDocumentScrolling: true,
  filterMatchMode: {
    text: [
      FilterMatchMode.STARTS_WITH,
      FilterMatchMode.CONTAINS,
      FilterMatchMode.NOT_CONTAINS,
      FilterMatchMode.ENDS_WITH,
      FilterMatchMode.EQUALS,
      FilterMatchMode.NOT_EQUALS,
    ],
    numeric: [
      FilterMatchMode.EQUALS,
      FilterMatchMode.NOT_EQUALS,
      FilterMatchMode.LESS_THAN,
      FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
      FilterMatchMode.GREATER_THAN,
      FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
    ],
    date: [
      FilterMatchMode.DATE_IS,
      FilterMatchMode.DATE_IS_NOT,
      FilterMatchMode.DATE_BEFORE,
      FilterMatchMode.DATE_AFTER,
    ],
  },
  zIndex: {
    modal: 1100,    // Dialog, Sidebar
    overlay: 1000,  // Dropdown, OverlayPanel
    menu: 1000,     // Overlay menus
    tooltip: 1100,  // Tooltip
    toast: 1200,    // Toast
  },
  autoZIndex: true,
};

root.render(
  <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <SnackbarProvider maxSnack={3} anchorOrigin={{vertical:'top',horizontal:"right"}}>
            <PrimeReactProvider value={primeReactConfig}>
              <App />
            </PrimeReactProvider>
          </SnackbarProvider>
        </PersistGate>
      </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
